export default __webpack_public_path__ + "static/media/profile.9dc6a263.jpg";